import { BpModules, PlanungModules } from "@bp/pim-auth-constants";

export type ModuleProduct = "planung" | "bp";

/** Module/feature catalog per product (from @bp/pim-auth-constants) with display
 *  labels. `clientId` is the product's frontend OAuth client, whose org-license
 *  edge carries the licensedModules. Shared by the editor + the read-only list. */
export const MODULE_CATALOG: Record<
  ModuleProduct,
  { clientId: string; label: string; modules: { value: string; label: string }[] }
> = {
  planung: {
    clientId: "planung-frontend-client",
    label: "Planung",
    modules: [
      { value: PlanungModules.timetable, label: "Stundenplan" },
      { value: PlanungModules.substitution, label: "Vertretung" },
      { value: PlanungModules.app, label: "Vertretungs-App" },
      { value: PlanungModules.teachingLoad, label: "Deputate" },
      { value: PlanungModules.teachingBlocks, label: "Epochen" },
      { value: PlanungModules.solver, label: "Solver" },
    ],
  },
  bp: {
    clientId: "bp-frontend-client",
    label: "Bildungsplattform",
    modules: [
      { value: BpModules.nextcloud, label: "Nextcloud" },
      { value: BpModules.threema, label: "Threema" },
      { value: BpModules.threemaBroadcast, label: "Threema Broadcast" },
      { value: BpModules.kiChat, label: "KI-Chat" },
      { value: BpModules.kiUnterricht, label: "KI-Unterricht" },
    ],
  },
};

/** Flat module-value → display-label lookup across all products. */
export const MODULE_LABEL: Record<string, string> = Object.fromEntries(
  Object.values(MODULE_CATALOG).flatMap((c) => c.modules.map((m) => [m.value, m.label])),
);

/** Human-readable label for a raw module id (falls back to the raw value). */
export function moduleLabel(value: string): string {
  return MODULE_LABEL[value] ?? value;
}
